module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_vm._v("Foreword")])]), _c('h1', {
    staticClass: "pre_stit"
  }, [_c('span', [_c('i', [_vm._v("Mark Batterson")])])])]), _c('div', {
    staticClass: "dev"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Prayer can sometimes be a frightening thing. How do we approach the Maker of the world? It begins by viewing prayer as a deeper experience than simply trying to elicit a response from God. It is natural to go to God when we need something, but how much more would our lives change if we had prayer as a natural rhythm and practice in our lives?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In "), _c('i', [_vm._v("Simple Prayer")]), _vm._v(", Charlie Dawes offers readers an opportunity to simplify their prayer life and in doing so, make it richer. Charlie has a strong passion to help people on their spiritual journey; he thrives on mentoring, teaching, and discipling, and this is evident to those around him. His love of people and pop culture makes his voice a unique and fresh connection between age-old wisdom and the twenty-first century.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This book will open the door for you to experience the same presence of God that you may feel during worship in your everyday life. It is never too late to become a person of prayer. It’s simple, straightforward, challenging, and hopeful. Charlie uses simple prayers to create a personal connection to God for all denominations.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("Prayer has been a central part of the Christian life for centuries and yet remains a point of anxiety for many. Prayer can feel difficult and burdensome, and Charlie offers a reminder that sometimes the most powerful prayers are the ones that are simple in ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("nature. It was his discovery of the ancient prayer known as the Jesus Prayer that introduced Charlie to a new rhythm of prayer. It was one that was focused on being with God more than talking to God. This knowledge from the past can be and is personal for today! "), _c('i', [_vm._v("Simple Prayer")]), _vm._v(" offers prayers that will be foundational in your prayer life, ministry, and relationships.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("I challenge you to let this book change how you pray. Prayer is more than a list. It’s not a stale transaction between you and God—prayer is an intimate part of your spirituality. Simple prayers are the catalyst you need for spiritual depth. This book is an invitation to allow simple prayers to shape your spiritual practice of prayer and to be the start of a beautiful journey in spiritual formation.")])])])])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 66
// module chunks = 0